import { useEffect, useState } from 'react';
import ButtonLabel from '../../../components/Button/ButtonLabel';
import Button from '../../../components/Button/Button';
import { createTokenRecoveryPassword } from '../../../services/tokenValidation';
import { useControllerFlowStepsContext } from '../../../hooks/ControllerFlowStepsContext';

import StepHeader from '../../../components/Wizard/StepHeader';
import Alert from '../../../components/Alert';
import { useNavigate } from 'react-router-dom';
import { useAccountRecoveryContext } from '../../../data/AccountRecovery/AccountRecoveryContext';
import ButtonGoogle from '../../../components/SocialMedia/ButtonGoogle';
import { SocialEnum } from '../../../enums/SocialEnum';
import { capitalizeFirstLetter, getEmailProvider } from '../../../utils/string';
import ButtonMicrosoft from '../../../components/SocialMedia/ButtonMicrosoft';
import ButtonApple from '../../../components/SocialMedia/ButtonApple';
import Separator from '../../../components/Separator';

export interface PasswordRecoverySocialProps {
  previousPath?: number | null;
  nextPath?: number | null;
  handleChangeStep(e: number): void;
  context: any;
}

export default function PasswordRecoverySocial({
  nextPath,
  handleChangeStep
}: PasswordRecoverySocialProps) {
  const navigate = useNavigate();

  const [provider, setProvider] = useState<SocialEnum | null>(null);
  const [errorMessage, setErrorMessage] = useState('');

  const [loading, setLoading] = useState(false);
  const { getOrigin } = useControllerFlowStepsContext();
  const { getValues } = useAccountRecoveryContext();

  useEffect(() => {
    setProvider(getEmailProvider(getValues('email')));
  }, []);

  function nextStep() {
    handleChangeStep(nextPath ?? 1);
  }

  function backPage() {
    navigate(
      `${getOrigin() == 'videos' ? '/videos/' : getOrigin() === 'sbt' ? '/sbt/' : '/'}signin`
    );
  }

  async function callCreateToken() {
    setLoading(true);
    const email = getValues('email');
    try {
      await createTokenRecoveryPassword(email);
      setLoading(false);
      nextStep();
    } catch (error: any) {
      setLoading(false);
      setErrorMessage(
        error?.statusCode === 429
          ? 'Você atingiu o limite de tentativas. Por favor, volte mais tarde.'
          : 'Não foi possível prosseguir com a alteração de senha para esse e-mail'
      );
    }
  }

  if (!provider) return null;

  return (
    <div className="card__section">
      <div className="card__top">
        <StepHeader
          title="Vamos recuperar seu acesso?"
          description={[
            'Notamos que você utilizou um e-mail do Google.',
            `Utilize a opção “Continuar com ${capitalizeFirstLetter(provider)}” e nunca mais se preocupe com senha para acessar sua Conta SBT.`
          ]}
        />

        <Alert message={errorMessage} onClose={setErrorMessage} />

        {provider === SocialEnum.GOOGLE ? (
          <ButtonGoogle showText />
        ) : provider === SocialEnum.MICROSOFT ? (
          <ButtonMicrosoft showText />
        ) : (
          <ButtonApple showText />
        )}

        <Separator text="ou" />

        <Button
          id="password-recovery"
          full
          onClick={callCreateToken}
          disabled={loading || !!errorMessage}
          className="smallest"
        >
          <ButtonLabel loading={loading}>Recuperar minha senha</ButtonLabel>
        </Button>
      </div>

      <div>
        <Button
          customColors="btn-ghost"
          full
          onClick={backPage}
          className="smallest"
        >
          <ButtonLabel>Voltar ao início</ButtonLabel>
        </Button>
      </div>
    </div>
  );
}
